import { HttpStatusCode } from '@angular/common/http';
import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';

import { LoggerService } from '../../core/logger/logger.service';
import { UserRegistrationDto } from '../../modules/users/dto/user-registration';
import { UsersService } from '../../modules/users/users.service';
import { ErrorMessages } from '../../shared/enums/error-messages.enum';
import { DataTypeUtils } from '../data-type.util';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
	constructor(
		private readonly loggerService: LoggerService,
		private readonly usersService: UsersService,
		private readonly injector: Injector,
	) {}

	handleError(err: any): void {
		if (
			environment.datadog.isEnabled && // desabilitado por padrão no ambiente de desenvolvimento
			!AppErrorHandler.isErrorIgnored(err.message) && // permite ignorar erros enviados pro Logger
			(!err.status || // Erro do cliente, deve ser reportado
				(err.status > HttpStatusCode.BadRequest &&
					err.status !== HttpStatusCode.Unauthorized &&
					err.status !== HttpStatusCode.Forbidden)) // Erro do servidor
		) {
			const router = this.injector.get(Router);

			const user: UserRegistrationDto | null = this.usersService.getUser();

			const person = user?.id
				? {
						id: user.id,
						email: user?.email || undefined,
						username: user?.name || undefined,
					}
				: undefined;

			try {
				const payload = {
					context: {
						route: router.url,
					},
					person,
				};

				this.loggerService.error(
					err.originalError.message || err.message,
					payload,
					err.originalError || err,
				);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Erro ao enviar relatório para o Datadog:');
			}
		} else {
			// eslint-disable-next-line no-console
			console.log('App Error Handler');
		}
	}

	static isErrorIgnored(message: string): boolean {
		message = DataTypeUtils.string.getFirstLine(message);
		switch (message) {
			case ErrorMessages.SseTimeout:
				return true;
			case ErrorMessages.RxJSMapOperators:
				return true;
			default:
				return false;
		}
	}
}
